import { render, staticRenderFns } from "./EditRoleModal.vue?vue&type=template&id=4430c4a7&"
import script from "./EditRoleModal.vue?vue&type=script&lang=js&"
export * from "./EditRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4430c4a7')) {
      api.createRecord('4430c4a7', component.options)
    } else {
      api.reload('4430c4a7', component.options)
    }
    module.hot.accept("./EditRoleModal.vue?vue&type=template&id=4430c4a7&", function () {
      api.rerender('4430c4a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/EditRoleModal.vue"
export default component.exports